import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'placeholder',
  standalone: true,
})
export class ImgPlaceholderPipe implements PipeTransform {
  transform(src: string | undefined | null): string {
    return !src || src.includes('null') || src.includes('undefined')
      ? 'https://placehold.co/600x400/png'
      : src;
  }
}
